import { render, staticRenderFns } from "./trips-page.vue?vue&type=template&id=76044062&scoped=true"
import script from "./trips-page.vue?vue&type=script&lang=js"
export * from "./trips-page.vue?vue&type=script&lang=js"
import style0 from "./trips-page.vue?vue&type=style&index=0&id=76044062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76044062",
  null
  
)

export default component.exports